import { useParams, Outlet } from '@tanstack/react-router';
import AsyncPageContainer from '_/common/components/layout/AsyncPageContainer';
import { useOrganization } from '_/contexts/OrganizationContext';
import DocumentTitle from '_/hooks/DocumentTitle';
import { useIntegration } from '_/hooks/useIntegrations';
import React, { ReactElement } from 'react';

interface RouteParams {
  orgSlug: string;
  integrationId: string;
}

function SelectedIntegration(): ReactElement {
  const params = useParams({ strict: false }) as Partial<RouteParams>;
  const integrationId = params.integrationId || '';
  const { selectedOrgSlug } = useOrganization();
  const { data: selectedIntegration, isLoading } = useIntegration(selectedOrgSlug, integrationId);

  DocumentTitle(`${selectedIntegration?.name || 'Integration'} :: ${location.pathname.split('/').pop()}`);

  return (
    <AsyncPageContainer isLoading={isLoading || !selectedIntegration}>
      <Outlet />
    </AsyncPageContainer>
  );
}

export default SelectedIntegration;
